export default __webpack_public_path__ + "static/media/smithsonian_logo.065ad588.png";